import axios from "utils/request/unisatBrc20"
import { useCallback, useEffect, useState } from "react"
import useBrc20Utils from "./useBrc20Utils"
import { useAppSelector } from "hooks/redux/hooks"

const useTransferableData = () => {
    const { fromToken }= useAppSelector((state) => state.coreInfo)
    const [dataList, setDataList] = useState([])
    const [availableBalance, setAvailableBalance] = useState('0')
    const { address, isBTC } = useBrc20Utils()
    
    const getDataList = useCallback(async () => {
        if(!fromToken) return
        if(!isBTC) return
        try {
            const result:any = await axios.get(`/address/${address}/brc20/${fromToken?.symbol}/info`)
            if(result) {
                const { transferableInscriptions = [], availableBalance = '0', historyInscriptions= [] } = result
                const historyList = historyInscriptions.map((item: any) => item.inscriptionId)
                const tempDataList = transferableInscriptions.filter((item: any) => item.confirmations > 0 && !historyList.includes(item.inscriptionId))
                setDataList(tempDataList)
                setAvailableBalance(availableBalance)
            }
        } catch(error) {

        }
    }, [address, fromToken, isBTC])

    useEffect(() => {
        getDataList()
    }, [getDataList])

    useEffect(() => {
        const timer = setInterval(() => {
            getDataList()
        }, 5000)

        return () => {
            clearInterval(timer)
        }
    }, [getDataList])

    return {
        dataList,
        availableBalance
    }
}

export default useTransferableData